import { render, staticRenderFns } from "./User-fans.vue?vue&type=template&id=ce60f984&scoped=true&"
import script from "./User-fans.vue?vue&type=script&lang=js&"
export * from "./User-fans.vue?vue&type=script&lang=js&"
import style0 from "./User-fans.vue?vue&type=style&index=0&id=ce60f984&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce60f984",
  null
  
)

export default component.exports